import { rpcCall } from './rpc-client';

export type RequestOtpResult = {
  otpChannel: string;
  otpLength: number;
  expiresIn: number;
  retryAfter: number;
};

export type VerifyOtpResult = {
  token: string;
};

export function requestOtp(
  phone: string,
  locale: string,
): Promise<RequestOtpResult> {
  return rpcCall<RequestOtpResult>('Auth.RequestOTP', { phone, locale });
}

export function verifyOtp(
  phone: string,
  code: string,
  locale: string,
  referrerId: number,
): Promise<VerifyOtpResult> {
  return rpcCall<VerifyOtpResult>('Auth.VerifyOTP', {
    phone,
    code,
    locale,
    referrerId,
  });
}
